import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const SimpleNegativeChart = ({ watchersData = {}, suffix }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: {
          show: false, // Oculta la barra de herramientas, incluido el menú de descarga
        },
        width: '100%',
      },
      colors: ["#008FFB", "#FF4560"],
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "80%",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
          const percent = Math.round((val / total) * 100);
          return percent + "%";
        },
        style: {
          fontSize: '13px',
        }
      },
      stroke: {
        width: 0,
        colors: ["#fff"],
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      yaxis: {
        show: false, // Oculta el eje Y completamente
      },
      xaxis: {
        show: false, // Oculta el eje X completamente
        labels: {
          show: false, // Oculta las etiquetas del eje X
        },
        axisBorder: {
          show: false, // Oculta el borde del eje X
        },
        axisTicks: {
          show: false, // Oculta los ticks/marcas del eje X
        },
      },
      tooltip: {
        show: false, // Oculta el tooltip
        shared: false,
        x: {
          formatter: function (val) {
            return val;
          },
        },
        y: {
          formatter: function (val) {
            return Math.abs(val);
          },
        },
      },
      title: {},
      legend: {
        show: false,
      },
    },
  });

  useEffect(() => {
    setChartData((prev) => ({
      ...prev,
      series: [
        {
          name: "Hombres",
          data: [watchersData.man || 0],
        },
        {
          name: "Mujeres",
          data: [watchersData.woman || 0],
        },
      ],
    }));
  }, [watchersData]);

  return (
    <div className="">
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={70}
          width={"100%"}
        />
      </div>
    </div>
  );
};

export default SimpleNegativeChart;
